module.exports = __webpack_public_path__ + "img/step3.c060fea6.png";